import NavLinkController from './nav-link.controller';
import { NavLinkProps } from './nav-link.model';

const NavLink = (props: NavLinkProps): JSX.Element => {
  return <NavLinkController {...props} />;
};

export default NavLink;
